import { DATE_FORMAT_EU, DATE_FORMAT_US } from "_utils/dateUtils";
import { RadioButton } from "components/forms/radioButton";
import { RadioGroupField } from "components/forms/radioGroupField";
import { TextField } from "components/forms/textField";
import { useCompany } from "domain/company/useCompany";
import React from "react";

import { Alert, Stack } from "@mui/material";

const CompanyField = () => {
  const { companyCodes } = useCompany();

  if (companyCodes.length < 2) {
    return <></>;
  }

  return (
    <div>
      <Alert severity="warning">
        Your user account is associated with more than one NetJets company. Please select only the company that is most
        appropriate for you.
      </Alert>
      <RadioGroupField name="companyCode" label="Company">
        {companyCodes.map((c) => (
          <RadioButton key={c} label={c.toUpperCase()} value={c} />
        ))}
      </RadioGroupField>
    </div>
  );
};

export const UserSettingsFields = () => {
  return (
    <Stack spacing={8}>
      <CompanyField />
      <Stack spacing={2}>
        <TextField name="defaultAirportCode" label="Default Airport Code" helperText="4-Character Airport Code" />

        <RadioGroupField name="isMetric" label="Units">
          <RadioButton label="Miles" value="false" />
          <RadioButton label="Km" value="true" />
        </RadioGroupField>

        <RadioGroupField name="dateFormat" label="Date Format">
          <RadioButton label="US (mm/dd/yyyy)" value={DATE_FORMAT_US} />
          <RadioButton label="EU (dd/mm/yyyy)" value={DATE_FORMAT_EU} />
        </RadioGroupField>
      </Stack>
    </Stack>
  );
};
